import React from 'react'
import MultiLocationRow from './MultiLocationRow'
import { EmptyState, ErrorState, LoadingState } from '../../Shared/Components/MappingStates'
import Shared from '../../Shared/mappingUi.module.css'
import Style from '../multiLocation.module.css'

const MultiLocationList = ({
    rows,
    erpLocations,
    ecommerceLocations,
    isLoading,
    loadError,
    isDisabled,
    onChange,
    onRemove
}) => {
    if (isLoading) {
        return <LoadingState message="Loading location details..." />
    }
    if (loadError) {
        return <ErrorState message={loadError} />
    }
    if (rows.length === 0) {
        return (
            <EmptyState
                icon="uil-map-marker"
                message="No location mappings yet"
                hint="Pick an ERP and an eCommerce location above, then add the pair."
            />
        )
    }

    return (
        <>
            <div className={`${Shared.grid} ${Style.grid} ${Shared.listHeader}`}>
                <span>ERP Location</span>
                <span />
                <span>eCommerce Location</span>
                <span>Default</span>
                <span className={Shared.listHeaderAction}>Action</span>
            </div>
            <ul className={Shared.list}>
                {rows.map((row) => (
                    <MultiLocationRow
                        key={row.rowId}
                        row={row}
                        erpLocations={erpLocations}
                        ecommerceLocations={ecommerceLocations}
                        isDisabled={isDisabled}
                        onChange={onChange}
                        onRemove={onRemove}
                    />
                ))}
            </ul>
        </>
    )
}

export default MultiLocationList
